import React, { useState, useEffect } from "react";
import { Box, Typography, Grid } from "@mui/material";

// Helper function to run the numbers
const runNumbers = (
  start: number,
  end: number,
  duration: number,
  setNumber: (num: number) => void
) => {
  const range = end - start;
  const stepTime = Math.abs(Math.floor(duration / range));
  let current = start;
  const increment = end > start ? 1 : -1;

  const timer = setInterval(() => {
    current += increment;
    setNumber(current);
    if (current === end) {
      clearInterval(timer);
    }
  }, stepTime);
};

const BusinessOutcomeComponent = () => {
  const [efficiency, setEfficiency] = useState<number>(0);
  const [pipeline, setPipeline] = useState<number>(0);
  const [conversion, setConversion] = useState<number>(0);
  const [cost, setCost] = useState<number>(0);

  useEffect(() => {
    runNumbers(0, 99, 3000, setEfficiency); // Run up to 30% efficiency
    runNumbers(0, 300, 3000, setPipeline); // Run up to 300% pipeline
    runNumbers(0, 70, 3000, setConversion); // Run up to 70% conversion
    runNumbers(0, -60, 3000, setCost); // Run up to -60% cost
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: "#f3f4f6",

        display: "flex",
        alignItems: "center",

        width: "100%",
      }}
      className="sm: flex flex-col-reverse lg:flex-row p-5  justify-around"
    >
      <Box
        className="w-full mt-8 lg:w-2/5 h-full component"
        sx={{
          backgroundImage: "url('/b-a.jpg')",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          position: "relative",
          height: "80vh",
          borderRadius: "20px",
        }}
      >
        <Box
          sx={{
            border: "2px solid rgb(255,165,54)",
            borderRadius: "15px",
            padding: "16px",
            textAlign: "center",
            background:
              "linear-gradient(79deg, rgba(0,66,100,0.9) 0%, rgba(0,21,20,0.9) 100%)",

            boxShadow: 3,
            position: "absolute",
            left: "45%",
            top:{xs:"50%",lg:"60%"},
          }}
        >
          <svg width="100" height="100" viewBox="0 0 36 36">
            <path
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
              stroke="rgb(255,165,54)"
              strokeWidth="2"
              strokeDasharray={`${efficiency}, 100`}
            />
          </svg>
          <Typography variant="h6" color="white">
            {efficiency}% Efficiency
          </Typography>
        </Box>
      </Box>

      {/* Right side (Text & Stats) */}
      <Grid className="w-full lg:w-6/12 component" item xs={12} md={6}>
        <div
          className="text-3xl /. leading-10 text-blue-950	lg:text-4xl "
          style={{ fontWeight: "bold", marginBottom: "35px" }}
        >
          Why are we Best in{" "}
          <span
            style={{
              background:
                "linear-gradient(-96deg, rgb(194 183 183 / 0%) 0%, rgb(255 249 220 / 4%) 28%, rgb(255, 162, 49) 100%, rgb(255 255 255 / 0%) 100%)",
              padding: "0px 2px",
              borderLeft: "2px solid rgba(253,150,16,1)",
            }}
          >
            Assignment Writing?
          </span>
        </div>
        <Typography
          variant="body1"
          sx={{ mt: 2, color: "black", marginBottom: "50px" }}
        >
         Over the years, many assignment writing services have come and gone, but Matt Scholar has consistently stayed at the forefront. Our commitment to quality has kept us ahead, focusing on hiring the best academic writers globally rather than investing heavily in promotion and advertisements. Despite the rising costs due to inflation, we ensure our service charges remain as low as possible. We specialize in handling urgent assignment writing orders, with deadlines sometimes just a few hours away. Our writers excel under pressure, delivering high-quality work without compromising on standards. Their professionalism and efficiency are unmatched, making them the best in the assignment writing field.
        </Typography>

        {/* Stats */}
        <Box
          className="gap-5"
          display="flex"
          justifyContent="space-between"
          mt={4}
        >
          <Box>
            <div
              className="text-center text-3xl"
              style={{ fontWeight: "bold", color: "rgb(255,165,54)" }}
            >
              {pipeline}%
            </div>
            <div className="text-center" style={{ color: "rgba(45,64,77,1)" }}>
              Increase in new pipeline generated
            </div>
          </Box>
          <Box>
            <div
              className="text-center text-3xl"
              style={{ fontWeight: "bold", color: "rgb(255,165,54)" }}
            >
              {conversion}%
            </div>
            <div style={{ color: "rgba(45,64,77,1)" }}>
              Increase in conversion
            </div>
          </Box>
          <Box>
            <div
              className="text-center text-3xl"
              style={{ fontWeight: "bold", color: "rgb(255,165,54)" }}
            >
              {cost}%
            </div>
            <div className="text-center" style={{ color: "rgba(45,64,77,1)" }}>
              Decrease in cost per content
            </div>
          </Box>
        </Box>
      </Grid>
    </Box>
  );
};

export default BusinessOutcomeComponent;
